import { CatchCoreModule } from '../../../catch-core/catch-core.module';
import { NgModule } from '@angular/core';
import { TestStepTableComponent } from './components/test-step-table/test-step-table.component';
import { FilterService, ConfirmationService, MessageService } from 'primeng/api';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RichTextFieldComponent } from '../../components/rich-text-field/rich-text-field.component';

@NgModule({
  declarations: [TestStepTableComponent],
  exports: [TestStepTableComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CatchCoreModule, RichTextFieldComponent],
  providers: [FilterService, ConfirmationService, MessageService, provideHttpClient(withInterceptorsFromDi())],
})
export class TestStepTableModule {}
